import React from 'react';
import { notificationStatuses, notificationKinds, noStates} from './../../helpers/trans';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { Link } from 'react-router-dom';
import ReceivedIcon from '@material-ui/icons/AddCircle';
import SignedIcon  from '@material-ui/icons/PlaylistPlay';
import CreatedIcon  from '@material-ui/icons/Subject';
import RejectedIcon  from '@material-ui/icons/Cancel';
import OutdatedIcon  from '@material-ui/icons/Alarm';
import ApprovedIcon from '@material-ui/icons/CheckCircle';
import FolderOpen from '@material-ui/icons/FolderOpen';

let counter = 0;

function desc(a, b, orderBy) {
    console.log(orderBy);
    let x  =  a[orderBy] ;
    let y  =  b[orderBy] ;
    if ((orderBy == 'last_edit_date' || orderBy ==  'registration_date') && x !== null &&  y!== null)  {
        console.log(a);
         x = x.split('.');
         x = x.reverse();
         x.join('');
         y = y.split('.');
         y = y.reverse();
         y.join('');
    }
    if (y < x) {
        return -1;
    }
    if (y > x) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy, rows,numSelected, rowCount } = this.props;

        return (
            <TableHead>
                <TableRow>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding='none'
                                style={row.style}
                                sortDirection={orderBy === row.id ? order : false}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement='bottom-start'
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
    rows: PropTypes.array.isRequired,
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
            : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
        },
    spacer: { flex: '1 1 100%',},
    actions: { color: theme.palette.text.secondary,},
    title: { flex: '0 0 auto',},
});

let EnhancedTableToolbar = props => {
    const { numSelected, classes } = props;

    return (
        <Toolbar
            className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
        >
            <div className={classes.title}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subtitle1">
                        {numSelected} selected
                    </Typography>
                ) : (
                    <Typography variant="h6" id="tableTitle">
                        {props.title}
                    </Typography>
                )}
            </div>
            <div className={classes.spacer} />
            <div className={classes.actions}>
                {numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Tooltip title="Filter list">
                        <IconButton aria-label="Filter list">
                            <FilterListIcon />
                        </IconButton>
                    </Tooltip>
                )}
            </div>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
});

class EnhancedTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: 'asc',
            orderBy: 'state',
            selected: [],
            page: 0,
            rowsPerPage: 15,
        };
    }


    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleClick = (event, id) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;

    render() {
        const { classes, items, title } = this.props;
        const { order, orderBy, selected, rowsPerPage, page } = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, items.length - page * rowsPerPage);
        const rows = [
            { id: 'id', numeric: true, label: '', style:{width:'16px'} },
            { id: 'status', numeric: false, disablePadding: false, label: 'Статус' },
            { id: 'last_edit_date', numeric: false, disablePadding: false, label: 'Дата последнего редактирования', style:{width:'8em'} }];

        if (this.props.type !== 'insp') {
            rows.push({ id: 'inspection_name', numeric: false, label: 'Инспекция' });
        }
        if (this.props.type !== 'org') {
            rows.push({ id: 'client_org_name', numeric: false, disablePadding: false, label: 'Наименование заказачика' });
        }
        rows.push({ id: 'submitted_by', numeric: false, disablePadding: false, label: 'Кем подписано' });
        rows.push({ id: 'object_name', numeric: false, disablePadding: false, label: 'Наименование объекта', style:{width: this.props.type == 'org' ? '20em': '40em'}});
        rows.push({ id: 'expertise_resolution_index',numeric: false, disablePadding: false, label: '№ Заключения экспертизы' });
        rows.push({ id: 'outgoing_number',numeric: false, disablePadding: false, label: 'Исходящий № уведомления' });
        rows.push({ id: 'ingoing_number',numeric: false, disablePadding: false, label: 'Bходящий № уведомления' });
        rows.push({ id: 'reply_number', numeric: false, disablePadding: false, label: 'Исходящий № извещения' });
        rows.push({ id: 'state', disablePadding: false, label: 'Статус извещения', style:{width:'1em'}});
        rows.push({ id: 'registration_number', numeric: false, disablePadding: false, label: 'Регистрационный № объекта' });
        rows.push({ id: 'registration_date', numeric: false, disablePadding: false, label: 'Дата регистрации' });
        if (this.props.type == 'org') { rows.push( {id: 'draft_url', numeric: false, disablePadding: false, label: 'Файл' })};
        if (this.props.type !== 'org' && false) {

            rows.push({ id: 'signed_url', numeric: false, disablePadding: false, label: 'Файл с ЭЦП' });
        }

        
        return (
            <Paper className={classes.root}>
                <EnhancedTableToolbar numSelected={selected.length} title={title} />
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            rows={rows}
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={items.length}
                        />
                        <TableBody style={{ height: '300px', overflowX: 'auto', overflowY: 'scroll'}}>
                            {stableSort(items, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(n => {


                                    let colors = {15:'#f4f5f7', 20:'#daf2e2', 50: '#FFF0F5', 5: '#f9f5c5'}
                                    return (

                                        <TableRow
                                            hover
                                            style={{backgroundColor: (n.state in colors) ? colors[n.state]:'#ffffff' }}
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={n.id}
                                        >
                                            <TableCell title='Открыть' style={{width: '16px', cursor:'pointer'}}><Link to={`/${this.props.openLink}/${n.id}`}><FolderOpen /></Link></TableCell>
                                            <TableCell style={{width: '1em', cursor:'pointer'}} padding='none'
                                                       title={notificationStatuses[n.status]}>{n.state < 5? <CreatedIcon /> : <SignedIcon />}</TableCell>
                                            <TableCell style={{width: '8em', textAlign:'center'}} padding='none'numeric>{n.last_edit_date}</TableCell>
                                            {(this.props.type !== 'insp') && (<TableCell style={{ textAlign:'left'}} >{n.inspection_name}</TableCell>)}
                                            {(this.props.type !== 'org') && (<TableCell padding="none" style={{textAlign:'left'}}>{n.client_org_name}</TableCell>)}
                                            <TableCell>{n.submitted_by}</TableCell>
                                            <TableCell padding='none' numeric
                                                       style={{width: this.props.type == 'org' ? '7em': '40em', textAlign:'center'}} title={n.object_name}>{n.object_name}</TableCell>
                                            <TableCell>{n.expertise_resolution_index}</TableCell>
                                            <TableCell style={{width: '3em', textAlign:'left'}}  padding='none' numeric>{n.outgoing_number}</TableCell>
                                            <TableCell style={{width: '3em', textAlign:'left'}} padding='none' numeric>{n.ingoing_number}</TableCell>
                                            <TableCell style={{width: '3em', textAlign:'center'}} padding='none' numeric>{n.reply_number}</TableCell>
                                            <TableCell style={{width: '1em', textAlign:'center'}} padding='none' numeric title={n.state in noStates ? noStates[n.state]: n.state}> {n.state == 10 ? <SignedIcon /> : n.state == 5 ? <OutdatedIcon/> : n.state == 15 ? <ReceivedIcon />: n.state == 20 ? <ApprovedIcon /> : n.state == 50 ? <RejectedIcon/> :``}</TableCell>
                                            <TableCell style={{width: '3em', textAlign:'left'}} padding='none' numeric>{n.registration_number}</TableCell>
                                            <TableCell style={{width: '3em', textAlign:'center'}} padding='none' numeric>{n.registration_date}</TableCell>
                                            {(this.props.type == 'org') && (<TableCell numeric>{(typeof n.draft_url !== "undefined"&& n.draft_url!== null && n.draft_url.length > 0)?(<a href={n.draft_url} target='_blank'>doc</a>):''}</TableCell>)}
                                            {(this.props.type!== 'org' && false) && (<TableCell numeric>{(typeof n.signed_url !== "undefined" && n.signed_url !== null && n.signed_url.length > 0)?(<a href={`${n.signed_url}`} target='_blank'>doc</a>):''}</TableCell>)}
                                             </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 26 * emptyRows }}>
                                    <TableCell colSpan={0.1} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                <TablePagination
                    rowsPerPageOptions={[15, 30, 50]}
                    component="div"
                    count={items.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
                    nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired
};

EnhancedTable.defaultProps = { type: 'admin'}

export default withStyles(styles)(EnhancedTable);



// WEBPACK FOOTER //
// ./assets/src/js/components/lists/NotificationList.jsx